import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CardsViewService {
  private _documentPath: string;

  get documentPath(): string {
    return this._documentPath;
  }

  set documentPath(doc: string) {
    if (this._documentPath) {
      this._documentPath = this._documentPath.concat('/', doc);
    } else {
      this._documentPath = doc;
    }
  }
}
